<template>
  <div class="reservation-payment-form">
    <div class="row">
      <div v-if="tab.id" class="col">
        <guest-tab :tab="tab" />
        <div
          v-if="tab.stats.balance_due > 0 && stripeConnected"
          class="deposit-collection"
          :invoiceTabId="tab.id"
        >
          <collect-deposit
            v-if="tab.id"
            :tabId="tab.id"
            :balance="tab.stats.balance_due"
          />
        </div>
      </div>

      <b-tooltip
        v-if="!tab.id"
        target="go-to-payments"
        placement="top"
        title="No tab associated with this booking. Please save booking before making payments to it."
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    tab: Object
  },

  components: {
    InfoRow: () => import('@/components/InfoRow'),
    GuestTab: () => import('@/components/GuestTab'),
    CollectDeposit: () => import('@/components/payments/CollectDeposit')
  },

  computed: {
    ...mapState({
      stripeConnected: state => !!state.vendor.vendor.stripe_id
    })
  }
};
</script>

<style lang="scss" scoped>
.reservation-payment-form {
  margin-bottom: 20px;
  text-align: center;
}
</style>
